<template>
    <main v-if="initiated" class="category">
        <template v-if="!products.length">
            <section class="category-header">
                <div class="container-fluid">
                    <div class="category-title mb-3">
                        <h1>{{ description ? description.header : 'Каталог' }}</h1>
                        <span class="pl-2 pt-1">0 моделей</span>
                    </div>
                </div>
            </section>
            <div class="container-fluid">
                <Empty/>
            </div>
        </template>
        <template v-else>
            <section v-if="brand && brand.options && brand.options.includes('show_seo')"
                     class="category-brand">
                <div class="container-fluid">
                    <div class="category-brand-logo">
                        <img :src="brand.logo" :alt="brand.name">
                    </div>
                    <div class="category-brand-info">
                        <div class="category-brand-description" v-html="brand.description"></div>
                        <span class="link link--more">Подробнее</span>
                    </div>
                </div>
            </section>
            <div class="container-fluid">
                <div v-if="stock" class="promo">
                    <div class="promo-content">
                        <div v-if="toggleFullDescription" class="promo-description">
                            <h4 class="promo-title">Условия акции</h4>
                            <p class="promo-text" v-html="stock.full_description"></p>
                        </div>
                        <div v-if="!toggleFullDescription" class="promo-description">
                            <h4 class="promo-title">{{ stock.title }}</h4>
                            <p class="promo-text">{{ stock.short_description }}</p>
                        </div>
                        <div class="promo-actions">
                            <div v-if="stock.end_time_timestamp && !promoCodeApplied" class="promo-timer">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px"
                                     height="13px">
                                    <path fill="currentColor"
                                          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                                </svg>
                                <span v-if="countdownDaysLeft">{{ countdownDaysLeft }} {{
                                        countdownDaysLabel
                                    }}</span>
                                <span>{{ countdownHoursLeft }} {{ countdownHoursLabel }}</span>
                                <span>{{ countdownMinutesLeft }} {{ countdownMinutesLabel }}</span>
                                <span v-if="!countdownDaysLeft">{{ countdownSecondsLeft }} {{
                                        countdownSecondsLabel
                                    }}</span>
                            </div>
                            <button v-if="stock.applicable"
                                    :disabled="promoCodeApplied"
                                    @click.prevent="applyPromoCode"
                                    title="Кликните чтобы применить"
                                    class="promo-apply">
                                <template v-if="!promoCodeApplied">
                                    Применить промокод: <span>{{ stock.code }}</span>
                                </template>
                                <template v-else>
                                    Промокод <span>{{ stock.code }}</span> применён
                                </template>
                            </button>
                        </div>
                        <button @click.prevent="toggleViewDescription" title="Условия акции"
                                class="promo-conditional">
                            Условия акции
                        </button>
                    </div>
                </div>
            </div>
            <filters v-if="filters"></filters>
            <section v-else class="category-header">
                <div class="container-fluid">
                    <div class="category-title mb-3">
                        <h1>{{ description ? description.header : 'Каталог' }}</h1>
                        <span v-if="pagination && pagination.total && isReady">{{ pagination.total }} модели</span>
                    </div>
                    <div v-if="$q.platform.is.mobile"
                         class="category-list category-filters category-filters--mobile">
                        <div class="category-list-inner">
                            <ul class="nav-list">
                                <li v-for="categoriesTree in categories" class="nav-item">
                                    <div class="nav-link"
                                         :class="{'nav-link--expand': categoriesTree.subCategories.length}">
                                        <div>
                                            <a :href="basePath + categoriesTree.slug + '/'
                                            + (brand ? 'brand_' + brand.slug + '/' : '')">{{
                                                    categoriesTree.name
                                                }}</a>
                                            <div v-if="categoriesTree.subCategories.length"
                                                 class="nav-link--show">{{ categoriesTree.subCategories.length }}
                                            </div>
                                        </div>
                                        <categories :categories-list="categoriesTree.subCategories"
                                                    :brand="brand"></categories>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div class="container-fluid category-container">
                <section class="category-list"
                         v-if="!$q.platform.is.mobile && categories">
                    <div class="category-list-inner">
                        <template v-if="categories">
                            <ul class="nav-list">
                                <li v-for="categoriesTree in categories" class="nav-item">
                                    <div class="nav-link"
                                         :class="{
                                            'nav-link--expand': categoriesTree.subCategories.length,
                                            'nav-link--active': categories.length === 1
                                        }">
                                        <div>
                                            <a :href="basePath + categoriesTree.slug + '/'
                                            + (brand ? 'brand_' + brand.slug + '/' : '')">{{
                                                    categoriesTree.name
                                                }}</a>
                                            <div v-if="categoriesTree.subCategories.length"
                                                 class="nav-link--show"></div>
                                        </div>
                                        <categories :categories-list="categoriesTree.subCategories"
                                                    :brand="brand"></categories>
                                    </div>
                                </li>
                            </ul>
                        </template>
                        <categories v-else :categories-list="categories[0].subCategories"></categories>
                        <a v-if="banner && banner.image" :href="banner.url" class="category-list-banner">
                            <img :id="banner.id ? banner.id : false"
                                 class="lazyload"
                                 src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                                 :data-src="banner.image"
                                 :alt="banner.title"
                                 :title="banner.title"
                                 width="230"
                                 height="157"
                            />
                        </a>
                    </div>
                </section>
                <section class="category-catalog">
                    <bestsellers v-if="bestsellers"></bestsellers>
                    <div class="category-catalog-inner">
                        <card v-for="(product, index) in productList"
                              :lazy-load="parseInt(index) > 3"
                              :key="product.id"
                              :product="product"
                              :promo-code="stock"
                              :show-article="showArticles"></card>
                    </div>
                    <div v-if="pagination && pagination.total_pages > 1">
                        <pagination v-if="isReady" :current-page="pagination.current_page"
                                    :total-pages="pagination.total_pages" @setPage="setPage"></pagination>
                    </div>
                    <div class="category-catalog-description" v-if="description && description.description"
                         v-html="description.description"></div>
                </section>
            </div>
        </template>
    </main>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import copy from 'copy-to-clipboard';
import Pagination from "./Pagination";
import countdown from './../mixins/countdown';
import Bestsellers from "./Catalog/Bestsellers";
import Categories from "./Catalog/Categories";
import Filters from "./Catalog/Filters";
import Empty from "./Catalog/Empty";
import Template from "./AdminPanel/Content/TemplateForm.vue";

export default {
    components: {
        Template,
        Pagination,
        Bestsellers,
        Categories,
        Filters,
        Empty
    },
    mixins: [
        countdown
    ],
    data() {
        return {
            pathName: location.pathname,
            initiated: false,
            stickySidebar: null,
            copied: false,
            banner: null,
            showArticles: false,
            stock: null,
            toggleFullDescription: false,
            brand: {},
        }
    },
    created() {
        this.banner = window.banner;
        this.$store.commit('catalog/setCategoryId', window.categoryId);
        this.$store.commit('catalog/setProducts', window.products);
        this.$store.commit('catalog/setPopularLinks', window.popularLinks);
        this.$store.commit('catalog/setSelected', window.selected);
        this.$store.commit('catalog/setBasePath', window.basePath);
        this.$store.commit('catalog/setRangeFilters', window.rangeFilters);
        this.$store.commit('catalog/setBreadcrumbs', window.breadcrumbs);
        this.$store.commit('catalog/setSkipFilters', window.skipFilters);
        this.$store.commit('catalog/setExpandCategories', window.expandCategories);
        this.$store.commit('catalog/setBestsellers', window.bestsellers);
        this.$store.commit('catalog/setSortOptions', window.sortOptions);
        this.$store.commit('catalog/setDescription', window.description);
        this.$store.commit('catalog/setCategories', window.categories);
        this.$store.commit('catalog/setFilterList', window.filterList);
        this.$store.commit('catalog/setPagination', window.pagination);
        this.$store.commit('catalog/setFilters', window.filters);
        this.$store.commit('catalog/setSections', window.sections);

        this.brand = window.brand;
        this.stock = window.stock && window.stock.end_time_timestamp ? window.stock : false;
        this.showArticles = !!window.showArticles;
    },
    mounted() {
        this.$store.commit('catalog/loaded');
        this.initiated = true;
        this.setPromoCodeStatus(!!window.promoCodeApplied);

        if (this.stock) {
            this.setCountdownEndTimestamp(this.stock.end_time_timestamp * 1000)
        }
    },
    watch: {
        categoryId(newValue, oldValue) {
            if (newValue && oldValue) {
                window.scrollTo({top: 0});
            }
        }
    },
    methods: {
        ...mapMutations('cart', [
            'setPromoCode'
        ]),
        ...mapActions('catalog', [
            'setCategoryId',
            'setPage',
        ]),
        ...mapMutations('catalog', [
            'setPromoCodeStatus'
        ]),
        copyToClipboard() {
            copy(this.stock.code);

            this.copied = true;
        },
        toggleViewDescription() {
            this.toggleFullDescription = !this.toggleFullDescription
        },
        applyPromoCode() {
            let _this = this;

            axios.post('/products/apply-promo-code/' + _this.stock.code)
                .then(response => {
                    _this.setPromoCodeStatus(true);
                    _this.setPromoCode(_this.stock.code);
                    _this.$store.dispatch('catalog/update');
                })
                .catch(error => {
                    console.log('failed');
                    console.log(error);
                });
        },
    },
    computed: {
        ...mapState('catalog', [
            'products',
            'pagination',
            'categories',
            'categoryId',
            'description',
            'basePath',
            'expandCategories',
            'bestsellers',
            'filters',
            'promoCodeApplied',
        ]),
        ...mapGetters('catalog', [
            'isReady',
        ]),
        hasProducts() {
            return window.products.length > 0;
        },
        productList() {
            return window.products;
        }
    }
}
</script>
